// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import AppsSearch from 'app/service/components/AppsSearch';
import { getRef, setRef } from 'app/common/utils/ReactUtils';
import 'app/viewport/components/Header/HeaderServiceSearch.scss';

import type { KindType } from 'app/common/types';

const bem = bemify('header-service-search');

type Props = {
  onRouteToService: (slug: string) => void,
  onTrack: (message: string, data: {}) => void,
  className?: string,
  kind?: KindType,
  isVisible: boolean,
  placeholder: string,
};

class HeaderServiceSearch extends React.Component<Props, *> {
  componentDidUpdate(prevProps: Props) {
    // When the search is revealed, then focus the input text box
    if (!prevProps.isVisible && this.props.isVisible) {
      const searchInputRef = getRef(this, 'searchInputElement');

      setTimeout(() => {
        if (searchInputRef) {
          searchInputRef.focus();
        }
      }, 0);
    }
  }

  render() {
    const {
      onRouteToService,
      onTrack,
      className,
      kind,
      placeholder,
    } = this.props;

    const onSelectApp = slug => {
      if (slug) {
        onTrack('Zapbook: App header search result selected', {
          slug,
        });

        onRouteToService(slug);
      }
    };

    return (
      <AppsSearch
        className={bem(className, toModifiers(kind))}
        inputRef={setRef(this, 'searchInputElement')}
        onBlur={() => onTrack('Zapbook: App Header search closed', {})}
        onFocus={() => onTrack('Zapbook: App Header search opened', {})}
        onResults={(query, hasResults) =>
          onTrack(
            `Zapbook: ${
              hasResults ? 'Results in search' : 'No results in search'
            }`,
            { searchTerm: query }
          )
        }
        onSelect={onSelectApp}
        placeholder={placeholder}
      />
    );
  }
}

export default HeaderServiceSearch;
